import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { Input } from '../../../ui/input';
import { Label } from '../../../ui/label';
import CustomSelect from '../../../ui/CustomSelect';
import { parseRupiah } from '../../../hris/recruitment/utils/formatRupiah';

interface FundRequirementSectionProps {
  loanPurpose: string;
  kreditUsulan: string | number;
  purposeCategory: string;
  onChange: (field: string, value: string | number) => void;
}

export default function FundRequirementSection({
  loanPurpose,
  kreditUsulan,
  purposeCategory,
  onChange,
}: FundRequirementSectionProps) {
  // Format currency untuk input field
  const formatCurrencyInput = (value: any): string => {
    if (!value && value !== 0) return '';
    const numValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d]/g, '')) : value;
    if (isNaN(numValue)) return '';
    return new Intl.NumberFormat('id-ID').format(numValue);
  };

  const handleCurrencyChange = (field: string, value: string) => {
    const rawValue = parseRupiah(value);
    if (rawValue === '') {
      onChange(field, '');
      return;
    }
    const numValue = parseFloat(rawValue);
    onChange(field, isNaN(numValue) ? '' : rawValue);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Kebutuhan Dana & Posisi Kas</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label>Tujuan Pinjaman</Label>
            <Input
              value={loanPurpose || ''}
              onChange={e => onChange('loan_purpose', e.target.value)}
              placeholder="Penambahan Modal Kerja dan Persediaan Penjualan"
              className="focus:border-blue-500"
            />
          </div>
          <div className="space-y-2">
            <Label>Nominal Dana yang Dibutuhkan</Label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">Rp</span>
              <input
                type="text"
                value={formatCurrencyInput(kreditUsulan)}
                onChange={e => handleCurrencyChange('kredit_usulan', e.target.value)}
                placeholder="0"
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200 text-right"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Kategori Tujuan Pinjaman</Label>
            <CustomSelect
              value={purposeCategory || ''}
              onChange={v => onChange('purpose_category', v)}
              placeholder="Pilih Kategori"
              width="w-full"
              color="blue"
              options={[
                {
                  value: 'Sewa / Pembelian Toko / Ruko / Kios',
                  label: 'Sewa / Pembelian Toko / Ruko / Kios',
                },
                { value: 'Modal Kerja', label: 'Modal Kerja' },
                { value: 'Investasi', label: 'Investasi' },
                { value: 'Konsumsi', label: 'Konsumsi' },
              ]}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
